export default {
  views: {
    basket: {
      shopNow: 'Shop Now',
      yourBasket: '<strong>Your Basket</strong> ({0} items): <strong>{1}</strong>',
      noItems: "We've got some neat stuff that your basket would love!",
      licenseTitle: 'License and Fees',
      licenseTotal: 'Total Licensing Fees',
      replacementTitle: 'Replacement Tags',
      tagTitle: 'Pet Tags',
      petProductTitle: 'Productos para mascotas y membresías',
      productTitle: 'Products',
      walletCardProductTitle: 'Wallet Cards',
      duplicateWalletCard: 'Duplicate Wallet Card',
      petIdentificationCard: 'Pet Identification Card',
      walletCardMissingInfo: 'Your Wallet Card is missing info!',
      walletCardFinishPet: "Finish {petName}'s card",
      walletCardAssignPet: 'Assign a pet to your card',
      additionalFeesTitle: 'Additional Fees',
      donationTitle: 'Donations',
      vsTitle: 'Items for Voice & Sight',
      vsPetTitle: 'Pets',
      vsGuardianTitle: 'Pet Owner Or Guardians',
      addAnother: [
        'BUY MORE & SAVE MORE ON TAGS!',
        'Add another tag and SAVE $5!',
        'Add another tag and SAVE $15!',
        'Add another tag for just $10!',
      ],
      checkout: 'Checkout',
      login: 'Login to Checkout',
      continueShopping: 'Continue Shopping',
      shipping: 'Free shipping on all orders over $00.00',
      returnPolicy: 'Something about our return policy',
      warranty: 'Something about our warranty',
      tooltip: {
        penaltyFee:
          'License fees are subject to a penalty if any person fails to pay the required license renewal fee within thirty (30) days of its due date. Penalty fees are cumulative based on the number of years a pet failed to be licensed.',
      },
      petTrackerAddedMessaging:
        '<strong>¡{petName} tiene mucha suerte! </strong> Ahora puedes mantenerte al tanto de su ubicación, salud y actividad con información en tiempo real directamente desde tu teléfono.',
    },
    confirmation: {
      thanks: 'Thank you for your purchase!',
      orderNumber: 'Order #{0}',
      gettingReady: "We're getting your order ready for shipment. We will notify you when it has been sent.",
      toAccount: 'Go to My Account',
      viewOrder: 'View your Order',
      summary: 'Order Summary',
      membershipCTA: {
        title: 'Más apoyo para ti y tus mascotas',
        body: 'Descubre beneficios mejorados de membresía que hacen que el cuidado diario de tu mascota sea fácil y agradable.',
        button: 'Explorar membresías',
      },
    },
    interrupt: {
      title: 'This tag is not a Pet License yet!',
      body: "We are the official licensing partner of {cityName}. In order for your selected tag(s) to double as your pet's license, you must purchase a license in addition to your selected tag(s). | We are the official licensing partner of {cityName}. In order for your selected tag(s) to double as your pets' license, you must purchase a license in addition to your selected tag(s).",
      buttonPurchaseLicense: 'Purchase a pet license now! | Purchase pet licenses now!',
      buttonContinue: "I understand. I'll purchase a pet license later! | I understand. I'll purchase pet licenses later!",
    },
    donation: {
      wouldYouLike: 'Would you like to make a donation to our Safe&Happy Fund?',
      netProceeds:
        'In {1} net proceeds collected through DocuPet’s Safe&Happy Fund are donated to {0}. Please note that donations made to the Safe&Happy Fund are not tax-deductible. You may receive a tax receipt if you donate to {0} directly.',
      selectAmount: 'Select your donation amount',
      continue: 'Add Donation and Continue to Checkout',
      skip: 'No Donation Today, Thanks - Continue',
      cartTotal: 'Cart Total: {0}',
      roundUpDonation: '<b>Round up my order to {0}</b><br />A donation of {1}',
      validation: {
        min: 'La donación personalizada mínima es de ${min}.',
        max: 'El monto máximo de donación personalizada es de ${max}.',
        invalid: 'Por favor, introduzca una cantidad de donación válida.',
      },
    },
    payment: {
      donationSuccess: 'Donation added. Thank you!',
      place: 'Place Your Order',
      shippingTo: 'Shipping to: ',
      editAddress: 'Edit',
      error: 'Uhoh! There was an error processing your card.',
      info: 'Payment Information',
      creditDebit: 'Credit Card',
      onFile: 'Card on File',
      useFile: 'Use Card on File',
      useDifferent: 'Use a Different Card',
    },
  },
  components: {
    discount: {
      notApplyTip:
        'Los códigos de promoción no se aplican a tarifas de licencias para mascotas, cargos por pagos atrasados, etiquetas de reemplazo para mascotas, artículos en paquete o artículos de oferta específicos.',
      success: '',
      error: '',
      excludesSaleItems: 'Promo Codes cannot be used on Sale items.',
      automatedDiscountBlocksPromo: 'Ya se aplicó un descuento de membresía a este pedido, por lo que no se pueden usar códigos promocionales.',
    },
    petHeader: {
      for: 'Items for {0}',
    },
    product: {
      personalization: 'Personalization',
      free: 'GRATIS',
      automatedDiscountLabel: {
        named: 'Descuento de {triggerName} aplicado',
        _default: 'Descuento automático aplicado',
      },
    },
    stripe: {
      AM: 'Amex',
      MC: 'Mastercard',
      VI: 'Visa',
      NN: 'Discover',
      XX: 'Card',
      profile: '{0} ending in {1} expiring on {2}/{3}',
    },
    totals: {
      subtotal: 'Subtotal',
      discount: 'Discount',
      shipping: {
        regular: {
          text: 'Regular Mail Shipping',
        },
        priority: {
          upgradeText: 'Upgrade to Priority Shipping ${0}',
          downgradeText: 'Change to Regular Mail Shipping (Free)',
        },
      },
      free: 'FREE',
      tax: 'Tax ({0}) {1}%',
      fees: 'Fees',
      feesTip: "Esta tarifa cubre los costos de completar su pedido.",
      replacementTagFees: 'Tarifa de procesamiento de etiqueta de reemplazo',
      replacementTagFeesTip: 'Se aplica una tarifa de procesamiento para ayudar a cubrir los cargos de tarjeta de crédito para procesar su pedido',
      donation: 'Donation',
      total: 'Total',
    },
    removeBundleItemConfirmation: {
      title: '¿Estás seguro de que quieres eliminar este artículo de tu canasta?',
      message: 'Esto eliminará todos los elementos asociados {petName} el paquete de identificación de mascotas.',
      messageNoPet: 'This will remove all of the items associated with the Pet ID Bundle.',
      confirmButtonText: 'Sí, elimine el elemento',
      cancelButtonText: 'No, mantenga este artículo',
    },
    petFooter: {
      chooseTagForNextPet: 'Escoge una placa para {petName}',
      addDesignerTag: '¡Agrega una etiqueta de diseñador para {petName}! | ¡Agrega otra etiqueta de diseñador para {petName}!',
    },
  },
  membership: {
    switchError: 'No pudimos cambiar la frecuencia de facturación. Inténtalo de nuevo.',
    switchToMonthly: 'Cambiar a facturación mensual ({price})',
    switchToAnnual: 'Cambiar a facturación anual y ahorra {saving}',
    switchToAnnualNoSaving: 'Cambiar a facturación anual ({price})',
    nowBilledMonthly: 'Ahora se factura mensualmente, {price} al mes.',
    nowBilledAnnually: 'Ahora se factura anualmente, {price} al año.',
    // Mirrored verbatim from translations/petowner/membership+intl-icu.es_US.xlf
    monthly_commitment_ack:
      'Entiendo que este es un compromiso de 1 año y acepto que se me facture automáticamente cada mes durante 12 meses.',
    monthly_commitment_ack_error: 'Marca la casilla para confirmar el compromiso de 1 año y las condiciones de facturación.',
  },
  meta: {
    title: {
      Basket: 'Basket',
      Checkout: 'Checkout',
      Interrupt: 'Interrupt',
      Donation: 'Donation',
      Payment: 'Payment',
      Confirmation: 'Confirmation',
    },
  },
};
